import React, { useEffect, useState } from "react";
import Inner_Footer_Text_Component from "../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import "./About_Profile.css";
import { getAllLearnMore } from "../../utils/apis/content/content";

const About_Profile = () => {
  const [learnMore, setLearnMore] = useState("");
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const getLearnMore = async () => {
    const res = await getAllLearnMore();
    if (res?.success) {
      setLearnMore(res.data);
    }
  };

  useEffect(() => {
    getLearnMore();
  }, []);
  return (
    <section className="About_Profile">
      <div className="heading_div">
        <p className="info_page_title">About Profile</p>
      </div>

      <div className="info_div">
        <p className="info_text">{htmlToReactParser.parse(learnMore?.name)}</p>
      </div>

      <div className="footer_div">
        <Inner_Footer_Text_Component />
      </div>
    </section>
  );
};

export default About_Profile;
